import React from "react";

import "../styles.css";

const LoanSummary = ({ data }) => {
  return (
    <div>
      <div className="d-flex flex-row detail-bold-text loan-summary-header loan-summary-content">
        <div className="loan-summary-label">Rincian Pinjaman</div>
        <div>Jumlah</div>
      </div>
      <div className="d-flex flex-row loan-summary-content">
        <div className="loan-summary-label">Nilai Pinjaman</div>
        <div>{data?.loanAmount}</div>
      </div>
      <div className="d-flex flex-row loan-summary-content">
        <div className="loan-summary-label">Sewa Modal</div>
        <div>{data?.capitalLoan}</div>
      </div>
      <div className="d-flex flex-row loan-summary-content">
        <div className="loan-summary-label">Biaya Administrasi</div>
        <div>{data?.feeAdmin}</div>
      </div>
      <div className="d-flex flex-row loan-summary-content">
        <div className="loan-summary-label">Biaya Simpan & Asuransi</div>
        <div>{data?.feeSavingAssurance}</div>
      </div>
      <div className="d-flex flex-row loan-summary-content">
        <div className="loan-summary-label">Biaya Transfer</div>
        <div>{data?.feeTransfer}</div>
      </div>
      <div className="d-flex flex-row detail-bold-text loan-summary-total loan-summary-content">
        <div className="loan-summary-label">Jumlah Diterima</div>
        <div>{data?.takenAmount}</div>
      </div>
    </div>
  );
};

export default LoanSummary;
